import React from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";

export default function WhsJobBanner({ jobData, headerText = "Job Site Context" }) {
  if (!jobData) return null;

  const address =
    [jobData.streetAddress, jobData.suburb, jobData.city, jobData.state]
      .filter(Boolean)
      .join(", ") || "Address not defined";

  return (
    <div className="bg-slate-50/90 border border-slate-200/80 p-3 rounded-2xl text-left space-y-1 shadow-xs font-sans">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-extrabold text-slate-400 uppercase tracking-widest">
          {headerText}
        </span>
        <span className="inline-flex items-center gap-1 bg-white border border-slate-200/80 px-2 py-0.5 rounded-full text-[10px] font-mono font-bold text-slate-600 shadow-2xs">
          ID: {jobData.displayJobId || jobData.jobId}
        </span>
      </div>
      <p className="text-xs font-black text-slate-900 leading-tight">
        {jobData.jobTitle || "Active Job Site"}
      </p>
      <div className="flex items-center gap-1.5 text-slate-500 text-[11px] font-medium pt-0.5">
        <MapPinIcon className="w-3.5 h-3.5 text-slate-400 shrink-0" />
        <span className="truncate">{address}</span>
      </div>
    </div>
  );
}
